import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "container-fluid pt-4 pb-5",
  id: "Explore"
}
const _hoisted_2 = { class: "row mt-5 d-flex flex-row justify-content-center align-items-center" }
const _hoisted_3 = { class: "inner col-12 col-lg-11 col-xl-10 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"row d-flex flex-column flex-lg-row justify-content-center align-items-center top\"><p class=\"col-12 col-lg-3 mb-0 title\"><span class=\"number\">3. </span><span>Explora y compara datos</span></p><div class=\"col-12 col-lg-1 mt-2 mb-4 my-lg-0 d-flex justify-content-center align-items-center\"><div class=\"line\"></div></div><p class=\"col-11 col-lg-8 mb-0 text text-center text-lg-start\">En esta sección puedes analizar una pregunta específica en distintas escalas (totales o porcentajes); visualizar la información de distintas maneras y crear cruces estadísticos con las variables sociodemográficas de tu preferencia (edad, sexo, educación, año, región del país, color de piel, religión, ingresos y condición de vulnerabilidad). Además, la plataforma te permitirá descargar tanto las tablas como los gráficos que generes ¡Es muy fácil!</p></div>", 1)
const _hoisted_5 = { class: "row col-12 mt-5 d-flex flex-row justify-content-center align-items-center mid" }
const _hoisted_6 = { class: "col-12 col-lg-5 topic" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "title mb-0" }, "Tema", -1)
const _hoisted_8 = { class: "col-12 col-lg-7 question" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "title mb-0" }, "Pregunta", -1)
const _hoisted_10 = {
  key: 0,
  class: "row col-12 mt-2 d-flex flex-row justify-content-between align-items-center sub"
}
const _hoisted_11 = { class: "col-12 col-lg-5 answer" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "title mb-0" }, "Respuesta", -1)
const _hoisted_13 = {
  key: 1,
  class: "row col-12 mt-2 d-flex flex-row justify-content-center align-items-center sub"
}
const _hoisted_14 = { class: "col-12 col-lg-9 agreggations" }
const _hoisted_15 = { class: "d-flex flex-row justify-content-center align-items-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "category-menu px-4 py-4 mt-1"
}
const _hoisted_18 = { class: "row d-flex flex-row justify-content-center align-items-center" }
const _hoisted_19 = { class: "col-6 col-lg-4 py-2 d-flex justify-content-center align-items-center" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "mb-0 text-center" }
const _hoisted_22 = { class: "row controls col-12 mt-5 mb-4 mx-0 px-5 d-flex flex-column flex-lg-row justify-content-between align-items-center" }
const _hoisted_23 = {
  key: 0,
  class: "col-12 col-lg-3 mb-3 mb-lg-0 switch d-flex flex-row justify-content-center align-items-center"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Total", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Porcentaje", -1)
const _hoisted_26 = {
  key: 1,
  class: "col-lg-3"
}
const _hoisted_27 = { class: "col-12 col-lg-9 labels d-flex flex-column justify-content-center align-items-center" }
const _hoisted_28 = { class: "mb-0 title text-uppercase text-center text-lg-center" }
const _hoisted_29 = {
  key: 0,
  class: "mb-0 mt-3 subtitle text-center"
}
const _hoisted_30 = { class: "row viz col-12 mt-4 mt-lg-0 d-flex flex-column flex-lg-row justify-content-center align-items-center" }
const _hoisted_31 = { class: "col-12 col-lg-2" }
const _hoisted_32 = { class: "row types d-flex flex-row flex-lg-column justify-content-center align-items-center" }
const _hoisted_33 = { class: "col-4 col-lg-4 px-2 py-3 d-flex justify-content-center align-items-center" }
const _hoisted_34 = ["src", "onClick"]
const _hoisted_35 = { class: "col-12 col-lg-10 my-5 chart" }
const _hoisted_36 = {
  key: 0,
  class: "text-start",
  style: {"font-size":"12px"}
}
const _hoisted_37 = {
  key: 1,
  class: "text-start",
  style: {"font-size":"12px"}
}
const _hoisted_38 = { class: "row col-12 download" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-none d-lg-block" }, null, -1)
const _hoisted_40 = { class: "col-12 col-lg-10 d-flex justify-content-center align-items-center" }
const _hoisted_41 = { class: "row d-flex justify-content-center align-items-center" }
const _hoisted_42 = { class: "col-12 col-lg-5 py-4 d-flex justify-content-center align-items-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "DESCARGAR DATOS SELECCIONADOS", -1)
const _hoisted_44 = { class: "col-12 col-lg-5 py-lg-4 d-flex justify-content-center align-items-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "DESCARGAR GRÁFICA SELECCIONADA", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_VueMultiselect, {
              class: "select",
              ref: "topic",
              modelValue: _ctx.currentTopic,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentTopic) = $event)),
              onSelect: _ctx.wantChangeTopic,
              options: _ctx.sections,
              "show-labels": false,
              placeholder: "Selecciona un tema",
              label: "title"
            }, null, 8, ["modelValue", "onSelect", "options"]),
            _createVNode(_component_v_icon, {
              class: "arrow",
              name: "fa-caret-down",
              scale: "2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.topic.activate()))
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_VueMultiselect, {
              class: "select",
              ref: "question",
              modelValue: _ctx.selectedQuestion,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedQuestion) = $event)),
              options: _ctx.questions,
              "show-labels": false,
              placeholder: "Selecciona una pregunta",
              label: "NOMBRE_CAMPO",
              onSelect: _ctx.wantChangeQuestion
            }, null, 8, ["modelValue", "options", "onSelect"]),
            _createVNode(_component_v_icon, {
              class: "arrow",
              name: "fa-caret-down",
              scale: "2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.question.activate()))
            })
          ])
        ]),
        (_ctx.selectedChart === 'map')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_VueMultiselect, {
                  class: "select",
                  ref: "answer",
                  modelValue: _ctx.selectedAnswer,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedAnswer) = $event)),
                  options: _ctx.answerOptions,
                  "show-labels": false,
                  placeholder: "Selecciona una respuesta",
                  onSelect: _ctx.changeAnswer,
                  label: "title"
                }, null, 8, ["modelValue", "options", "onSelect"]),
                _createVNode(_component_v_icon, {
                  class: "arrow",
                  name: "fa-caret-down",
                  scale: "2",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$refs.answer.activate()))
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedChart !== 'map')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: "category-btn col-12 title px-4 py-2 mt-4 d-flex flex-row justify-content-between align-items-center",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openCategories = !_ctx.openCategories))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.categories_hydrated.length === 0 ? "Desagrega hasta dos categorías" : ""), 1),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories_hydrated.filter(c => c.cat_class === 'active'), (c) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "selected-category mx-3 px-3 py-1 d-flex justify-content-center align-items-center",
                        onClick: ($event: any) => (_ctx.changeSelected(c, 'remove'))
                      }, _toDisplayString(`${c.key}   x`), 9, _hoisted_16))
                    }), 256))
                  ]),
                  _createVNode(_component_v_icon, {
                    class: "arrow",
                    name: "fa-caret-down",
                    scale: "2"
                  })
                ]),
                (_ctx.openCategories)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories_hydrated, (category) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["col-12 btn px-5 py-3", category.cat_class]),
                              onClick: ($event: any) => (_ctx.changeSelected(category)),
                              _class: "`${selectedX.key==category.key ? '' : 'in'}active`",
                              _disabled: "selectedX.key==category.key"
                            }, [
                              _createElementVNode("p", _hoisted_21, _toDisplayString(category.value), 1)
                            ], 10, _hoisted_20)
                          ]))
                        }), 256))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          (_ctx.selectedChart == 'bars')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_Toggle, {
                  class: "mx-3",
                  modelValue: _ctx.isPercentage,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isPercentage) = $event)),
                  onChange: _ctx.changeIsPercentage
                }, null, 8, ["modelValue", "onChange"]),
                _hoisted_25
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedChart !== 'bars')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.selectedQuestion.NOMBRE_CAMPO), 1),
            (_ctx.selectedChart == 'map')
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, "Respuesta: " + _toDisplayString(_ctx.selectedAnswer.title), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chart_types, (chart) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("img", {
                    src: require(`@/assets/images/${chart.image}${_ctx.selectedChart === chart.name ? 'On' : 'Off'}.svg`),
                    onClick: ($event: any) => (_ctx.changeChart(chart.name))
                  }, null, 8, _hoisted_34)
                ]))
              }), 256))
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_Chart, {
              parent: "explore",
              chart: _ctx.selectedChart
            }, null, 8, ["chart"]),
            (_ctx.selectedQuestion.NEMONICO ? _ctx.selectedQuestion.NEMONICO.includes('AP6_3_') : false)
              ? (_openBlock(), _createElementBlock("p", _hoisted_36, "* El porcentaje se calcula a partir de las personas que afirman haber participado alguna vez en la vida en la organización respectiva de la pregunta"))
              : _createCommentVNode("", true),
            (_ctx.selectedQuestion.NEMONICO ? _ctx.adultQuestions.includes(_ctx.selectedQuestion.NEMONICO)  : false)
              ? (_openBlock(), _createElementBlock("p", _hoisted_37, "* Pregunta que aplica solo para mayores de edad (18 años y más)"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("button", {
                  class: "btn px-4 py-3 d-flex juatify-content-center align-items-center",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadData()))
                }, [
                  _createVNode(_component_DownloadIcon, { class: "icon me-2" }),
                  _hoisted_43
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  class: "btn px-4 py-3 d-flex juatify-content-center align-items-center",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadChart()))
                }, [
                  _createVNode(_component_DownloadIcon, { class: "icon me-2" }),
                  _hoisted_45
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}